import { Button } from '@chakra-ui/react';
import { pdf } from '@react-pdf/renderer';
import PickupDetailsPdfTemplate from 'components/pdfs/PickupDetailsPDFTemplate';
import { useState } from 'react';
import { MdUpload } from 'react-icons/md';
import { Pickup } from 'types/pickup';
import { SKU } from 'types/sku';

type PickupDetailsPDFGeneratorProps = {
  pickup: Pickup;
  skuData: SKU[];
  isRacked?: boolean;
};

const PickupDetailsPDFGenerator = ({
  pickup,
  skuData,
  isRacked = false,
}: PickupDetailsPDFGeneratorProps) => {
  const [loading, setLoading] = useState(false);

  const fileName = `Pickup Harvest - ${pickup?.site?.name} - ${pickup?.pickupNumber}.pdf`;

  const handleGenerateAndDownload = async () => {
    setLoading(true);
    const blob = await pdf(
      <PickupDetailsPdfTemplate
        data={pickup}
        skuData={skuData}
        isRacked={isRacked}
      />,
    ).toBlob();

    const link = document.createElement('a');
    const blobUrl = window.URL.createObjectURL(blob);
    link.href = blobUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    setLoading(false);
  };

  return (
    <Button onClick={handleGenerateAndDownload} isLoading={loading} gap="10px">
      <MdUpload />
      Export PDF
    </Button>
  );
};

export default PickupDetailsPDFGenerator;
